import { useLocale } from 'next-intl';

import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

import { businessCaseStudiesOR4 } from './data/data';

const BusinessCaseStudy = (): JSX.Element => {
  const locale = useLocale();
  const testimonials = businessCaseStudiesOR4(locale);

  return (
    <section className="pb-20" data-cy="business-case-study">
      <LandingPageTestimonials
        testimonials={testimonials}
        theme="darkSandstone"
      />
    </section>
  );
};

export default BusinessCaseStudy;
